<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formAdministrationSanitizationPg" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12">
            <h3>Portada</h3>
          </v-col>
          <v-col cols="12" md="2">
            <label for="title_cover_page">Título de Portada</label>
          </v-col>

          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="title_cover_page"
              v-model="administrationSanitizationPg.title_cover_page"
              outlined
              dense
              placeholder="Título de la Portada"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <label for="img_cover_page">Imagen de Portada</label>
          </v-col>

          <v-col cols="12" md="4" class="pb-0">
            <v-file-input
              id="img_cover_page"
              v-model="file_cover_page"
              outlined
              prepend-icon=""
              dense
              placeholder="Elige una imagen"
              @change="onFileChange"
            ></v-file-input>
          </v-col>

          <v-col cols="12">
            <div class="img-cover section">
              <img
                draggable="false"
                :src="url || loadImage(administrationSanitizationPg.img_cover_page)"
                :alt="administrationSanitizationPg.text"
              />
              <h1 class="cover-title">{{ administrationSanitizationPg.title_cover_page }}</h1>
            </div>
          </v-col>

          <v-col cols="12">
            <h3>Saneamiento de inmuebles</h3>
          </v-col>

          <v-col cols="12" md="2">
            <label for="sanitization_description">Descripcion de saneamiento</label>
          </v-col>

          <v-col cols="12" md="10" class="pb-0">
            <v-textarea
              id="sanitization_description"
              v-model="administrationSanitizationPg.sanitization_description"
              outlined
              dense
              placeholder="Descripción de Saneamiento"
              rows="5"
              :rules="required"
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="2">
            <label for="state_total">Total de Inmuebles</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="state_total"
              v-model="administrationSanitizationPg.state_total"
              outlined
              dense
              placeholder="Título de Acerca de Nosotros"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <label for="states_sanitized">% de lotes saneados</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="states_sanitized"
              v-model="administrationSanitizationPg.states_sanitized"
              outlined
              dense
              placeholder="Título de Acerca de Nosotros"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <label for="states_in_process_sanitization">% de lotes en proceso de saneamiento</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="states_in_process_sanitization"
              v-model="administrationSanitizationPg.states_in_process_sanitization"
              outlined
              dense
              placeholder="Título de Acerca de Nosotros"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <h3>Administración de inmuebles</h3>
          </v-col>

          <v-col cols="12" md="2">
            <label for="administration_description">Descripcion de administration</label>
          </v-col>

          <v-col cols="12" md="10" class="pb-0">
            <v-textarea
              id="administration_description"
              v-model="administrationSanitizationPg.administration_description"
              outlined
              dense
              placeholder="Cargo del Funcionario"
              rows="5"
              :rules="required"
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="2">
            <label for="administrated_state_commerce">Cantidad de comercios</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="administrated_state_commerce"
              v-model="administrationSanitizationPg.administrated_state_commerce"
              outlined
              dense
              placeholder="Título de Acerca de Nosotros"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <label for="administrated_state_sanitary_facilities">Cantidad de Servicios Higienicos</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="administrated_state_sanitary_facilities"
              v-model="administrationSanitizationPg.administrated_state_sanitary_facilities"
              outlined
              dense
              placeholder="Título de Acerca de Nosotros"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <label for="administrated_state_dwelling">Cantidad de Viviendas</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="administrated_state_dwelling"
              v-model="administrationSanitizationPg.administrated_state_dwelling"
              outlined
              dense
              placeholder="Título de Acerca de Nosotros"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <h3>Inmuebles que Administra EMILIMA</h3>
          </v-col>
          <v-col cols="12">
            <DataTableManagedPublicPlaces></DataTableManagedPublicPlaces>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import DataTableManagedPublicPlaces from '@/components/data-table/DataTableManagedPublicPlaces.vue'
import { loadAPIImage } from '@/utils/images'
export default {
  components: {
    FormTemplate,
    DataTableManagedPublicPlaces,
  },
  props: {
    getAdministrationSanitizationPg: Function,
    loading: Boolean,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      url: '',
      urlNew: '',
      file_cover_page: null,
      file_about: null,
      administrationSanitizationPg: {},
    }
  },
  async created() {
    this.administrationSanitizationPg = await this.getAdministrationSanitizationPg()
  },
  methods: {
    validateForm() {
      return this.$refs.formAdministrationSanitizationPg.validate()
    },
    reset() {
      this.$refs.formAdministrationSanitizationPg.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      let DTO = { ...this.administrationSanitizationPg }

      if (this.file_cover_page) {
        DTO = {
          ...DTO,
          file_cover_page: this.file_cover_page,
        }
      }

      if (this.file_about) {
        DTO = {
          ...DTO,
          file_about: this.file_about,
        }
      }

      // // console.log('actualizar', DTO)
      this.$emit('beforeUpdate', DTO)
    },
    onFileChange(e) {
      if (!e) return
      this.url = URL.createObjectURL(e)
    },
    onFileNewChange(e) {
      if (!e) return
      this.urlNew = URL.createObjectURL(e)
    },
    loadImage(src) {
      return loadAPIImage(src)
    },
  },
}
</script>

<style lang="scss" scoped>
.img-cover {
  height: 30vh;
  max-height: 400px !important;
  min-height: 250px !important;
  position: relative;
}

.img-cover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.img-cover .cover-title {
  width: 100%;
  position: absolute;
  bottom: 10%;
  color: white !important;
  font-size: 25px;
  margin-left: 10%;
  text-transform: uppercase;
}

.img-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.img-about {
  width: 100%;
}

.title-about {
  font-size: 25px;
  font-weight: 800;
  text-transform: uppercase;
}

.content-about {
  display: flex;
  align-items: center;
}

.text-about {
  white-space: pre-wrap;
  font-size: 14px;
}

.section {
  margin: 0 auto;
  max-width: 900px;
}
</style>
